<template>
    <div class="w-100" style="">
        <p class="mb-2 text-md-start border-bottom text-center text-md-start">
            Today's playcount audiobook
        </p>
        <h5 class="mb-0 text-center text-md-start text-white fw-bold">
            {{count}}
        </h5>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data(){
        return{
            count:null
        }
    },

    methods:{
        async playCount(){
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/today-total-play-count-audiobook",{
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/json",
                    }
                }
            );
            if(res.status==200){
                this.count = res.data[0].total_played
            }
        }
    },
    created(){
        this.playCount()
    }
}
</script>
